import { makeStyles } from "@material-ui/core/styles";
import {
  THEME_PRIMARY_COLOR,
} from "../../../Constants";

const useStyles = makeStyles((theme) => ({
  formControlLabelBlack: {
    color: THEME_PRIMARY_COLOR,
    width: 103,
  },
  mobileTextInput: {
    width: "70%",
    "&>div": {
      width: "100%",
      "&>div": {
        height: 40,
        // marginLeft:theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
          width: "100%",
        },
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  signUpTextInput: {
    "&>div": {
      "&>div": {
        height: 40,
      },
    },
  },
  mobileInputStyle: {
    width: "80%",
    marginLeft: theme.spacing(2),
  },
  fullWidthBox: {
    width: "100%",
  },
  otpInputStyle: {
    border: "1px solid black",
    borderRadius: "8px",
    width: "54px",
    height: "54px",
    fontSize: "12px",
    color: "#000",
    fontWeight: "400",
    caretColor: "blue",
  },
  buttonWidth: {
    width: "100%",
    marginTop: "5%",
  },
  // navTextHover: {
  //   '&:hover': {
  //     // height:80,
  //     // color: theme.palette.text.primary,  //'white',
  //     // backgroundColor: theme.palette.secondary.main,  //`${theme.palette.primary.main}`
  //   },
  //   transition: 'all 0.5s ease'
  // },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
    marginLeft: theme.spacing(3),
  },
  navBarText: {
    justifyContent: "center",
    whiteSpace: "pre",
    alignItems: "center",
    color: theme?.agentTheme?.primary?.main,
    fontSize: "14px",
    fontWeight: 600,
  },
  navBarTextContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  navLink: {
    height: "inherit",
    // [theme.breakpoints.down('sm')]: {
    //   color:'black'
    // }
  },
  loginButtonStyle: {
    height: "38px",
    width: "135px",
    color: theme?.agentTheme?.primary?.main,
    [theme.breakpoints.down("sm")]: {
      height: "38px",
      width: "76px",
    },
  },
  resendOtpStyle: {
    color: theme.agentTheme.background.foreground,
    marginTop: theme.spacing(2),
    cursor: "pointer",
  },
  disabledResendOtpStyle: {
    color: theme.agentTheme.text.light,
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
    cursor: "pointer",
  },
  timer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  inputFormControlMedium: {
    width: 110,
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      width: "180px",
      // height:50
    },
  },
  inputFormControlMediumSignUp: {
    width: 110,
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      width: "100px",
      // height:50
    },
  },
}));

export default useStyles;
